import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Action.css'

const Action = ({ icon, topName, bottomName, link }) => {
    const navigate = useNavigate();
    
    const handleClick = () => {
        navigate(link);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate(link);
        }
    };

    return (
        <div 
            className='action' 
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            role="button"
            aria-label={`Navigate to ${topName} ${bottomName}`}
        >
            <div className='action-icon'>{icon}</div>
            <div className='action-top-name'>{topName}</div>
            <div className='action-bottom-name'>{bottomName}</div>
        </div>
    );
}

export default Action